import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../Context/PermissionContext';

/**
 * Protected Route Component
 * Protects routes based on RBAC permissions
 */
const ProtectedRoute = ({
  children,
  featureCode,
  redirectTo = '/inventory',
  fallback = null
}) => {
  const { hasPermission } = usePermissions();

  // featureCode may be one code or several. Several means ANY-OF: the route
  // opens on one of them. Asset Management is three tabs behind three
  // features, and a user granted only Assets must still reach the page.
  // Existing single-code callers are unaffected -- one code is an array of one.
  const featureCodes = Array.isArray(featureCode) ? featureCode : [featureCode];

  if (!featureCodes.some((code) => hasPermission(code, 'view'))) {
    console.warn(
      `[ProtectedRoute] Access denied to feature: ${featureCodes.join(' | ')}`
    );

    // Return custom fallback or redirect
    if (fallback) {
      return fallback;
    }

    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default ProtectedRoute;
